import { css } from 'aphrodite';
import * as React from 'react';
import { IAccount } from '../../../extViewmodels';
import { SubverticalSettingsContent } from '../SubverticalSelect';
import { styleSheet } from './styles';

interface IProps {
	/** The account whose subvertical settings are being configured. */
	account: IAccount;
	/**
	 * Called when the rep is done with this tab. SubverticalSettingsContent owns Save and Cancel, and
	 * fires this for both - in a tab flow, Cancel reads as "skip this one", so both move on.
	 */
	onDone: () => void;
}

/**
 * Post-meeting "Industry & Subvertical" tab. Wraps the same SubverticalSettingsContent the admin
 * account detail page opens, so a rep can fill in a blank subvertical right after recording a
 * meeting note rather than going back to the account later.
 */
export const SubverticalSettingsTab: React.FC<IProps> = ({ account, onDone }) => {
	return (
		<div className={css(styleSheet.confirmationColumn, styleSheet.confirmationColumnFull)}>
			<div className={css(styleSheet.summaryNote)}>
				This account has no subvertical selected. Picking one sharpens the content suggestions they get.
			</div>
			<SubverticalSettingsContent
				account={account}
				containerStyles={[styleSheet.subverticalContainer]}
				onClose={onDone}
			/>
		</div>
	);
};
